
import { useEffect, useState } from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import { useKeycloak } from "@react-keycloak/web";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useSpeechToText } from './SpeechToText';

export const NavAvatarBar = (props) => {

    const [user, setUser] = useState([]);
    const { keycloak } = useKeycloak();

    const {isListening,resumeListening,stopListening } = useSpeechToText();

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
         setUser(items);
        }
      }, []);

 return (
    <Navbar expand="lg" className="bg-body-tertiary">
        <img style={{ padding: "10px", width: "180px"}} src="https://www.interlogica.it/wp-content/uploads/2021/10/logo_interlogica_1.svg" />
        <Navbar.Brand href="#">{props.title}</Navbar.Brand>
    <Container>
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
            { isListening === false ?
                <button hidden={props.hidden} className="btn btn-primary" onClick={resumeListening}><i class="bi bi-mic"></i></button>
                : <button hidden={props.hidden} className="btn btn-danger" onClick={stopListening}><i class="bi bi-mic-mute"></i></button>
            }
        </Nav>
      </Navbar.Collapse>
      <Navbar.Collapse className="justify-content-end">
          <Navbar.Text>
            Signed in as: <a href="#"  onClick={() => {  localStorage.setItem('user',null);  keycloak.logout();  }}  >{ user.full_name }</a>
          </Navbar.Text>
        </Navbar.Collapse>
    </Container>
  </Navbar>
 );
};

